import axios from '@/libs/api.request'
// 角色列表
export const apiRoleList = data => {
  return axios.request({
    url: '/admin/admin-role',
    method: 'get',
    data,
  })
}
// 角色新增
export const apiRoleAdd = data => {
  return axios.request({
    url: '/admin/admin-role',
    method: 'post',
    data,
  })
}
// 角色详情
export const apiRoleDetail = (id,data) => {
  return axios.request({
    url: `/admin/admin-role/${id}`,
    method: 'get',
    data,
  })
}
// 角色编辑
export const apiRoleEdit = (id,data) => {
  return axios.request({
    url: `/admin/admin-role/${id}`,
    method: 'put',
    data,
  })
}
// 角色删除
export const apiRoleDelete = (id,data) => {
  return axios.request({
    url: `/admin/admin-role/${id}`,
    method: 'delete',
    data,
  })
}